import { BannerErrorConfigModel } from '../../../Common/Misc/models/banner-error-config.model';

export enum ContactEditBannerErrorTypeEnum {
    CONTACT_EDITOR_FIRSTNAME_ERROR = 'ContactEditorFirstNameError',
    CONTACT_EDITOR_LASTNAME_ERROR = 'ContactEditorLastNameError',
    CONTACT_EDITOR_EMAIL_ERROR = 'ContactEditorEmailError'


}

export const bannerErrorsMap = new Map<string, BannerErrorConfigModel>([
    [ContactEditBannerErrorTypeEnum.CONTACT_EDITOR_FIRSTNAME_ERROR,
        {errorId: 'contactEditor_firstName_error',label: 'Discover.contactEditor.fields.firstName.label'}],
    [ContactEditBannerErrorTypeEnum.CONTACT_EDITOR_LASTNAME_ERROR,
        {errorId: 'contactEditor_lastName_error',label: 'Discover.contactEditor.fields.lastName.label'}],
    [ContactEditBannerErrorTypeEnum.CONTACT_EDITOR_EMAIL_ERROR,
        {errorId: 'emailChips',label: 'Discover.contactEditor.fields.email.label'}]

]);

